import './Tabs.less';

export const prefix = 'oc-c-tabs';

export { default } from './Tabs';